// extracted by mini-css-extract-plugin
module.exports = {"root":"CheckBoxes_root__IYyHZ","noPad":"CheckBoxes_noPad__ZG5Dl","p":"CheckBoxes_p__1Rb05","warn":"CheckBoxes_warn__3Ona5"};